import { Box, CircularProgress } from '@mui/material';
import React, { memo } from 'react';
import { notificationsLoader } from '../../constants';
// padding необходим, чтобы scrollbar не дергался
var loaderSx = {
    textAlign: 'center',
    padding: 10,
};
export var Loader = memo(function () {
    return (React.createElement(Box, { sx: loaderSx, className: notificationsLoader },
        React.createElement(CircularProgress, { disableShrink: true })));
});
